
import sapSvg from '../assets/providers/sap.svg';
import s3Svg from '../assets/providers/amazon.svg';
import n8nSvg from '../assets/providers/n8n.svg';
import prioritySvg from '../assets/providers/priority.svg';
import azureSvg from '../assets/providers/azure.svg';
import mssqlSvg from '../assets/providers/mssql.svg';
import sapRfcSvg from '../assets/providers/sap.svg';
import { Activity, Key, Shield, Users } from 'lucide-react';
import { ConnectionConfig } from '../types/types';

export type TypeMetaItem = {
    key: string;
    icon: string;
    id: number;
    title: string;
    description: string;
    route: string;
};

export const typeMeta: TypeMetaItem[] = [
    {
        key: 'sap',
        icon: sapSvg,
        id: 1,
        title: 'SAP Connection',
        description: 'Configure your SAP system connection settings',
        route: '/connectors/sap',
    },
    {
        key: 's3',
        icon: s3Svg,
        id: 2,
        title: 'S3 Connection',
        description: 'Configure your AWS S3 connection for storage',
        route: '/connectors/s3',
    },
    {
        key: 'n8n',
        icon: n8nSvg,
        id: 3,
        title: 'n8n Connection',
        description: 'Configure your n8n workflow automation connection',
        route: '/connectors/n8n',
    },
    {
        key: 'priority',
        icon: prioritySvg,
        id: 4,
        title: 'Priority Connection',
        description: 'Configure your priority connection settings',
        route: '/connectors/priority',
    },
    {
        key: 'generic',
        icon: azureSvg, // Using azureSvg as placeholder - you may want to add a generic icon
        id: 5,
        title: 'Generic Connection',
        description: 'Configure your generic connection settings',
        route: '/connectors/generic',
    },
    {
        key: 'microsoft-graph',
        icon: azureSvg,
        id: 6,
        title: 'Microsoft Graph API',
        description: 'Configure your Microsoft Graph API connection settings',
        route: '/connectors/microsoft-graph',
    },
    {
        key: 'mssql',
        icon: mssqlSvg,
        id: 7,
        title: 'MSSQL Connection',
        description: 'Configure your Microsoft SQL Server or Microsoft Fabric SQL connection',
        route: '/connectors/mssql',
    },
    {
        key: 'sap-rfc',
        icon: sapRfcSvg,
        id: 8,
        title: 'SAP RFC Connection',
        description: 'Configure your SAP RFC / BAPI connection',
        route: '/connectors/sap-rfc',
    },
];

/**
 * Get a type meta item by its key
 */
export function getTypeMeta(connectionTypeId: number): TypeMetaItem | undefined {
    return typeMeta.find(item => item.id === connectionTypeId);
}

/**
 * Get type meta by connection config id
 * Finds the connection by id, then returns the meta based on its type
 */
export function getTypeMetaByConnectionConfigId(
    connectionConfigId: string | undefined,
    connectors: ConnectionConfig[],
): TypeMetaItem | undefined {
    if (!connectionConfigId) {
        return undefined;
    }
    const connection = connectors.find(c => c.id === connectionConfigId);
    if (!connection) {
        return undefined;
    }
    return getTypeMeta(connection.connectionTypeId);
}


// Define a list of tabs to centralize tab data
export const managementsTabs = [
    {
        id: 'users',
        label: 'Users',
        icon: Users,
        //   count: () => users.length,
    },
    {
        id: 'api-keys',
        label: 'API Keys',
        icon: Key,
        //   count: () => apiKeys.length,
    },
    {
        id: 'sso',
        label: 'SSO Configuration',
        icon: Shield,
    },
    {
        id: 'logs',
        label: 'Logs',
        icon: Activity,
    },
];